export default import.meta.ROLLUP_FILE_URL_OtGdDypMjNBsd7KRa_uQKw